// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/management/resources/tenant_plan.proto (package gx.management.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../database/models/public_pb.js";
import { file_services_management_resources_tenant_plan_configuration_tenant_plan_configuration } from "./tenant_plan_configuration/tenant_plan_configuration_pb.js";

/**
 * Describes the file services/management/resources/tenant_plan.proto.
 */
export const file_services_management_resources_tenant_plan = /*@__PURE__*/
  fileDesc("Ci9zZXJ2aWNlcy9tYW5hZ2VtZW50L3Jlc291cmNlcy90ZW5hbnRfcGxhbi5wcm90bxIXZ3gubWFuYWdlbWVudC5yZXNvdXJjZXMitAEKElRlbmFudFBsYW5SZXNvdXJjZRIKCgJpZBgBIAEoCRIvCglwbGFuX3RpZXIYAiABKA4yHC5neC5kYXRhYmFzZS5tb2RlbHMuUGxhblRpZXISYQoNY29uZmlndXJhdGlvbhgDIAEoCzJKLmd4Lm1hbmFnZW1lbnQucmVzb3VyY2VzLnRlbmFudF9wbGFuX2NvbmZpZ3VyYXRpb24uVGVuYW50UGxhbkNvbmZpZ3VyYXRpb25C9wEKG2NvbS5neC5tYW5hZ2VtZW50LnJlc291cmNlc0IPVGVuYW50UGxhblByb3RvUAFaSWdpdGh1Yi5jb20vZ2FsYXh5LWlvL2d4L3NoYXJlZC9nby9jb250cmFjdHMvc2VydmljZXMvbWFuYWdlbWVudC9yZXNvdXJjZXOiAgNHTVKqAhdHeC5NYW5hZ2VtZW50LlJlc291cmNlc8oCF0d4XE1hbmFnZW1lbnRcUmVzb3VyY2Vz4gIjR3hcTWFuYWdlbWVudFxSZXNvdXJjZXNcR1BCTWV0YWRhdGHqAhlHeDo6TWFuYWdlbWVudDo6UmVzb3VyY2VzYgZwcm90bzM", [file_services_database_models_public, file_services_management_resources_tenant_plan_configuration_tenant_plan_configuration]);

/**
 * Describes the message gx.management.resources.TenantPlanResource.
 * Use `create(TenantPlanResourceSchema)` to create a new message.
 */
export const TenantPlanResourceSchema = /*@__PURE__*/
  messageDesc(file_services_management_resources_tenant_plan, 0);

